'use strict';

var objectWithoutProperties = require('../../../node_modules/@babel/runtime/helpers/objectWithoutProperties.js');
var classNames = require('classnames');
var React = require('react');
var Theme = require('../../../Theme/Theme.js');
require('../../../Theme/DarkTheme.js');
require('../../../Theme/LightTheme.js');
var Grid = require('../../Layout/Grid/Grid.js');
var makeStyles = require('../../Styles/makeStyles.js');
var Typography = require('../Typography/Typography.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var classNames__default = /*#__PURE__*/_interopDefaultLegacy(classNames);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var useStyles = makeStyles["default"](function (theme) {
  return {
    container: {
      margin: '0 0 10px 0',
      '&:last-of-type > div:before, &:last-of-type > div:after': {
        opacity: 1
      }
    },
    bubble: {
      maxWidth: '80%',
      borderRadius: 20,
      padding: '10px 12px',
      display: 'inline-block',
      position: 'relative',
      backgroundColor: function backgroundColor(props) {
        return props.bubbleColor || theme.palette.primary.main;
      },
      '&:before, &:after': {
        content: "''",
        opacity: 0,
        position: 'absolute',
        bottom: 0
      },
      '&:before': {
        zIndex: 0,
        right: -7,
        height: 20,
        width: 20,
        backgroundAttachment: 'fixed',
        borderBottomLeftRadius: 15,
        backgroundColor: function backgroundColor(props) {
          return props.bubbleColor || theme.palette.primary.main;
        }
      },
      '&:after': {
        zIndex: 1,
        right: -10,
        width: 10,
        height: 20,
        background: 'white',
        borderBottomLeftRadius: 10
      },
      '&.yours': {
        backgroundColor: theme.palette.grey[200],
        '&:before': {
          right: 0,
          left: -7,
          background: theme.palette.grey[200],
          borderBottomLeftRadius: 0,
          borderBottomRightRadius: 15
        },
        '&:after': {
          right: 0,
          left: -10,
          background: 'white',
          borderBottomLeftRadius: 0,
          borderBottomRightRadius: 10
        }
      }
    }
  };
});

var ChatBubble = function ChatBubble(_ref) {
  var bubbleColor = _ref.bubbleColor,
      fontColor = _ref.fontColor,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'mine' : _ref$variant,
      children = _ref.children;
      objectWithoutProperties(_ref, ["bubbleColor", "fontColor", "variant", "children"]);

  var classes = useStyles({
    bubbleColor: bubbleColor
  });
  var passedFontColor = variant === 'mine' ? fontColor || Theme.theme.palette.common.white : Theme.theme.palette.text.primary;
  var messageJustify = variant === 'mine' ? 'flex-end' : 'flex-start';
  return React__default["default"].createElement(Grid, {
    container: true,
    direction: "row",
    justify: messageJustify,
    alignItems: "center",
    spacing: 0,
    className: classNames__default["default"](classes.container, variant)
  }, React__default["default"].createElement("div", {
    className: classNames__default["default"](classes.bubble, variant)
  }, React__default["default"].createElement(Typography // TODO: update Typography typings since this prop is treated as required
  , {
    // TODO: update Typography typings since this prop is treated as required
    component: "p",
    variant: "body2",
    style: {
      color: passedFontColor
    }
  }, children)));
};

module.exports = ChatBubble;
